const archeologyPackageId = 12

/**
 * @typedef { Object } ApplicationUrls
 * @property { string } test
 * @property { string } develop
 * @property { string } production
 */

/**
 * @type { Object<number, ApplicationUrls> }
 */
const urls = {
  [archeologyPackageId]: {
    test: 'https://office.archeology.test.terraindex.com/',
    develop: 'https://office.archeology.test.terraindex.com/',
    production: 'https://office.archeology.terraindex.com/'
  }
}

/**
 * @param { number } packageId
 * @param { string } environment
 * @returns { string | undefined } external application url
 */
export function getRedirectUrl(packageId, environment) {
  const applicationUrls = urls[packageId]
  if (!applicationUrls) return undefined

  return applicationUrls[environment]
}
